import { QueryClient } from "@tanstack/react-query"

/**
 * The app's one QueryClient (index.tsx). Requests wait for the network
 * themselves (connectivity.ts), so queries never pause: a paused query
 * reports `isLoading: false` without data, which pages render as empty
 * instead of loading.
 *
 * `networkMode: "always"` also turns React Query's reconnect refetch off by
 * default (`refetchOnReconnect = networkMode !== "always"`), so it is switched
 * back on: a query that gave up while offline, like the conversation messages
 * with no retry and no refetch on focus, would otherwise stay failed after the
 * health check finds the network back.
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: { networkMode: "always", refetchOnReconnect: true },
      mutations: { networkMode: "always" },
    },
  })
